export enum UserLockType {
    Admin = 'admin',
    TooManyPasswordAttemps = 'tooManyPasswordAttemps',
    AbuseOfUse = 'abuseOfUse',
}